import React from 'react';
import {Image, View} from 'react-native';
import {Images} from '../../constants/Images';

const PromotionBadge = () => {
  return (
    <View
      style={{
        position: 'absolute',
        top: 14,
        right: 6,
        zIndex: 3,
        width: 30,
        height: 30,
        backgroundColor: '#FFFFFF',
        borderRadius: 15,
      }}>
      <Image
        source={Images.saleIcon}
        style={{width: 30, height: 30}}
      />
    </View>
  );
};

export default PromotionBadge;
